export const login = 'oauth/token'
export const logout = 'logout'
export const jenisSurat = 'jenis-surat'
export const suratMasuk = 'surat-masuk'
export const disposisi = 'disposisi'
export const suratKeluar = 'surat-keluar'
export const userInfo = 'user'
export const jabatan = 'jabatan'
export const bidang = 'bidang'
export const users = 'users'
export const admin = 'admin'
export const agenda = 'agenda'
export const arsipSuratMasuk = 'arsip-surat-masuk'
export const arsipSuratKeluar = 'arsip-surat-keluar'
export const reportSummary = 'report/summary'
export const reportSuratMasuk = 'report/surat-masuk'
export const reportSuratKeluar = 'report/surat-keluar'
export const reportAgenda = 'report/agenda'
export const klasifikasiSurat = 'kode-surat'
